$(document).ready(function () {
  const functions = {
    init(items, mapId, zoom = 10, mapCenterCoords = [55.753559, 37.609218]) {
      if (items.length === 0) {
        return
      }

      let map = new ymaps.Map(mapId, {
        center: mapCenterCoords,
        zoom: zoom,
        controls: ['zoomControl', 'fullscreenControl'],
      })

      for (const data of items) {
        if (
          parseInt(parseFloat(data.long).toFixed(0)) !== 0
          && parseInt(parseFloat(data.lat).toFixed(0)) !== 0
        ) {
          const placemarkProps = {iconContent: data.label}
          if (data.phone) {
            placemarkProps.balloonContent = '<a href="tel:' + data.phone + '">' + data.phone + '</a>'
          }

          map.geoObjects.add(
            new ymaps.Placemark(
              [data.lat, data.long],
              placemarkProps,
              {
                preset: 'islands#redStretchyIcon',
                iconColor: 'red',
              },
            ),
          )
        }
      }

      map.behaviors.enable('scrollZoom')
    },

    prepareDataFromHtmlTag(items) {
      let result = []

      for (const item of items) {
        result.push(item.dataset)
      }

      return result
    }
  }

  ymaps.ready(() => {
    if ($(document).has('#contacts_map').length > 0) {
      const data = functions.prepareDataFromHtmlTag($('.contacts-container').find('.station-item'))

      const $map = $('#contacts_map');
      const $long = $map.data('long');
      const $lat = $map.data('lat');
      const $zoom = $map.data('zoom');

      functions.init(data, 'contacts_map', $zoom, [$lat, $long])
    }

    if ($(document).has('#services_map').length > 0) {
      const data = functions.prepareDataFromHtmlTag($('.b-autoservice-list').find('.list-item'))

      functions.init(data, 'services_map')
    }

    if ($(document).has('#single_station_map').length > 0) {
      const data = functions.prepareDataFromHtmlTag($('.station-data'))

      functions.init(data, 'single_station_map', 16, [data[0].lat, data[0].long - 0.004])
    }

    if ($(document).has('#all_services_map').length > 0) {
      const data = functions.prepareDataFromHtmlTag($('.map-data').find('.station-item'))

      const $map = $('#all_services_map');
      const $long = $map.data('long');
      const $lat = $map.data('lat');
      const $zoom = $map.data('zoom');

      functions.init(data, 'all_services_map', $zoom, [$lat, $long])
    }

    if ($(document).has('#header_station_map_container_mobile').length > 0) {
      const data = functions.prepareDataFromHtmlTag($('.list-header_stations'))

      const $map = $('#header_station_map_container_mobile');
      const $long = $map.data('long');
      const $lat = $map.data('lat');
      const $zoom = $map.data('zoom');

      functions.init(data, 'header_station_map_container_mobile', $zoom, [$lat, $long])
    }

    if ($(document).has('#header_station_map_container_desktop').length > 0) {
      const data = functions.prepareDataFromHtmlTag($('.list-header_stations'))

      const $map = $('#header_station_map_container_desktop');
      const $long = $map.data('long');
      const $lat = $map.data('lat');
      const $zoom = $map.data('zoom');

      functions.init(data, 'header_station_map_container_desktop', $zoom, [$lat, $long])
    }
  })
})

